import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_weuw966vgj: FaireBrandEntity = {
  token: "b_weuw966vgj",
  type: "brand",
  name: "Learning Lane Sensory Toys",
  avatarUrl:
    "https://cdn.faire.com/fastly/04efe506bcc8f660ee11715c2d61a5178dc7fdcdb74d18d76c231493e1c00c17.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/14654c09479b2cafb8fda78e34e076e90b5f012322baeab97e805e7d4cab8433.png",
  logoUrl:
    "https://cdn.faire.com/fastly/04efe506bcc8f660ee11715c2d61a5178dc7fdcdb74d18d76c231493e1c00c17.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/14654c09479b2cafb8fda78e34e076e90b5f012322baeab97e805e7d4cab8433.png",
  location: "Del City, OK, USA",
  minimumOrderDollars: 75,
  rating: 4.8,
  reviewCount: 21,
  isInsider: true,
  description:
    "Our company was founded by a special education teacher and prides itself on offering affordable fidget and sensory toy options.  We understand the financial constraints of owning a small business and that is why we try to source products at the lowest possible price and we NEVER require minimum quantities of products.  We know that in this industry there are a lot of very similar products, but we try to work with our factories on achieving styles, color combinations, etc. that are distinct from the others.  \n\n(Because we are use multiple factories and we try to bring you the lowest prices, our products are not all packaged the same, sometimes they are boxed, sometimes they are in plastic bags and sometimes in organza drawstring bags.  The same product ordered on separate occasions may not be packaged the same way.)  New products are added and restocked multiple times a week so check back often!!  We look forward to building long-lasting retailer relationships on Faire!!",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:58.163Z",
    importedBy: "entity-db-cli",
  },
};
